





import { Component, Vue, Prop } from 'vue-property-decorator';
import NumberCard from '../../dealer/cards/NumberCard.vue';
import { DashboardStatistics_auditStatistics } from '@/types/intrador';

@Component({
  components: {
    NumberCard,
  },
})
export default class AuditsWithAnomaliesCard extends Vue {
  @Prop(Object) private auditStatistics!: DashboardStatistics_auditStatistics;
  @Prop(String) private currentDateId!: string;

  private get auditsWithAnomalies() {
    return this.auditStatistics.withAnomaliesByMonth.find((status) =>
      status?.name === this.currentDateId)?.count ?? 0;
  }
}
